module.exports = __webpack_public_path__ + "img/school_logo3.b47003a8.png";